import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { usePermission } from '../../../../../../../hooks/usePermission';
import usePresentations from '../../../../../../../hooks/usePresentations';
import { Slot } from '../../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../../reduxToolkit/typedRedux';
import InlineEditButton from '../../../../../pageBuilder/InlineEditButton';
import { PresentationBookingButton } from '../presentationTicket/PresentationBookingButton';
import { PresentationJoinButton } from '../presentationTicket/PresentationJoinButton';
import PresentationEditComponent from '../PublicPresentation/PresentationEditComponent';

export const PresentationListItem = (props: { slot: Slot; index: number; textColor?: string }) => {
  const { slot, index, textColor } = props;

  const { t } = useTranslation();
  const { joinPresentation } = usePresentations();
  const { isBoothHost } = usePermission();

  const globalEditMode = useSelector(({ common }) => common.templateEditMode);
  const user = useSelector(({ common }) => common.user);

  const [editing, setEditing] = useState(false);

  return (
    <div className="flex ">
      {!editing ? (
        <div
          className={`flex flex-col @md:flex-row w-full py-8 px-4 space-y-2 @md:space-y-0 @md:space-x-4 @md:items-center ${
            index % 2 !== 0 ? 'bg-black bg-opacity-20' : ''
          }`}>
          <div className="@md:w-1/6 break-words">
            <p>{format(new Date(slot.datetime_start), 'dd.MM.yyy HH:mm')}</p>
          </div>
          <div className="break-words grow">
            <p className="font-bold">
              {slot.meetingroom.booth.name} {slot.meetingroom.name}
            </p>
            <p>{slot.meetingroom.contactperson}</p>
          </div>

          {!globalEditMode && (
            <div className="break-words flex flex-col @md:items-center space-y-2 @md:pr-8">
              <PresentationBookingButton customHtmlColor={textColor} slot={slot} />
              <PresentationJoinButton customHtmlColor={textColor} slot={slot} onClick={() => joinPresentation(slot)} />
            </div>
          )}
        </div>
      ) : (
        <PresentationEditComponent useList meetingroom={slot.meetingroom} />
      )}
      {globalEditMode && (
        <div className="relative">
          <InlineEditButton
            className="absolute top-0 right-0"
            isEditMode={editing}
            setIsEditMode={() => {
              setEditing(!editing);
            }}
            tooltip={t('account:edit-presentation')}
            forceShow={isBoothHost(user, [slot.meetingroom.booth])}
          />
        </div>
      )}
    </div>
  );
};
